import { render, staticRenderFns } from "./subGameTrend.vue?vue&type=template&id=914a6f06"
import script from "./subGameTrend.vue?vue&type=script&lang=ts"
export * from "./subGameTrend.vue?vue&type=script&lang=ts"
import style0 from "./subGameTrend.vue?vue&type=style&index=0&id=914a6f06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports